import {
    Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, tableCellClasses, IconButton, CircularProgress, Chip, Grid, InputLabel,
    FormControl,
    Select,
    MenuItem,
    ListItemText,
    Tooltip,
    Checkbox,
    InputAdornment,
    Button,
    styled,
    PaginationItem,
    Pagination,
} from '@mui/material';
import { PDFExport } from '@progress/kendo-react-pdf'
import { FontFamily, Images } from 'assets'
import Colors from 'assets/Style/Colors'
import { PrimaryButton } from 'components/Buttons'
import InputField from 'components/Input';
import { CircleLoading } from 'components/Loaders'
import { showErrorToast, showPromiseToast } from 'components/NewToaster'

import SelectField from 'components/Select'
import { useAuth } from 'context/UseContext'
import { useCallbackPrompt } from 'hooks/useCallBackPrompt';
import moment from 'moment';

import React, { Fragment, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom';
import CustomerServices from 'services/Customer'
import InvoiceServices from 'services/Invoicing'
import SystemServices from 'services/System';
import ExcelJS from "exceljs";
import { Debounce } from 'utils';
import { setExcelJsAutoFilter } from "utils/excelDate";
import DatePicker from 'components/DatePicker';
import { ErrorToaster } from 'components/Toaster';
import { LoaderIcon } from 'react-hot-toast';
// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
    border: 0,

}));

const Cell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 14,
        fontFamily: 'Public Sans',
        border: '1px solid #EEEEEE',
        padding: '15px',
        textAlign: 'left',
        whiteSpace: 'nowrap',
        color: '#434343',
        paddingRight: '50px',
        background: 'transparent',
        fontWeight: 'bold'

    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontFamily: 'Public Sans',

        textWrap: 'nowrap',
        padding: '5px !important',
        paddingLeft: '15px !important',
        '.MuiBox-root': {
            display: 'flex',
            gap: '6px',
            alignItems: 'center',
            justifyContent: 'center',
            '.MuiBox-root': {
                cursor: 'pointer'
            }
        },
        'svg': {
            width: 'auto',
            height: '24px',
        },
        '.MuiTypography-root': {
            textTransform: 'capitalize',
            fontFamily: FontFamily.NunitoRegular,
            textWrap: 'nowrap',
        },
        '.MuiButtonBase-root': {
            padding: '8px',
            width: '28px',
            height: '28px',
        }
    },
}));

const CreateMonthlyInvoice = () => {
    const navigate = useNavigate()
    // const [handleBlockedNavigation] =
    //     useCallbackPrompt(true)
    const { register, handleSubmit, getValues, setValue, control, formState: { errors }, reset } = useForm();
    // *For Customer Queue
    const [customerQueue, setCustomerQueue] = useState([]);
    const { user, userLogout } = useAuth();
    const [loader, setLoader] = useState(false)
    // *For Filters
    const [filters, setFilters] = useState({});
    const [totalCount, setTotalCount] = useState(0);
    const [totalCandidateCount, setTotalCandidateCount] = useState(0);
    const [pageLimit, setPageLimit] = useState(2);
    const [currentPage, setCurrentPage] = useState(1);
    const [candidates, setCandidates] = useState([])
    const [sort, setSort] = useState('asc')
    const [charges, setCharges] = useState(0)
    const [selectedCustomer, setSelectedCustomer] = useState(null)
    const tableHead = [{ name: 'Select', key: 'created_at' }, { name: 'Candidate Name', key: 'name' }, { name: 'Customer', key: 'commission_visa' }, { name: 'Passport Number', key: 'commission_visa' }, { name: 'Total Service Charges', key: 'commission_monthly' }, { name: 'Applicable Service Charges', key: 'commission_monthly' }, { name: 'Overstay Charges', key: 'commission_monthly' }]
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState(false)
    const [deselectedArray, setDeselectedArray] = useState([])
    const [totalData, setTotalData] = useState([])
    const [originalArray, setOriginalArray] = useState([])
    const [searchVal, setSearchVal] = useState('')
    const [salaryCharges, setSalaryCharges] = useState([])

    const [items, setItems] = useState([]); // Your array of items
    const [page, setPage] = useState(1);
    const itemsPerPage = 50; // Change this to the number of items you want per page

    const pageCount = Math.ceil(candidates?.length / itemsPerPage);

    const handleChangePage = (event, value) => {

        setPage(value);
        PaginationFunc(null, value)
    };

    let startIndex
    let endIndex
    let displayedItems


    const getCharges = async (id) => {

        if (!id) {
            return [];
        }

        console.log(id);
        try {
            let params = {
                customer_id: id

            }

            const { data } = await CustomerServices.getCharges(params);
            console.log(data, 'charges');
            setSalaryCharges(data?.charges || [])
            console.log(data?.charges, 'datadatadata');

            return data?.charges || [];


        } catch (error) {
            return [];

        }

    }
    // useEffect(() => {
    //     getCandidateList(null, null, null, selectedCustomer?.id)
    // }, [salaryCharges])

    function getApplicableCharge(data, inputDate, salary) {


        if (!inputDate) {
            return 0;
        }
        const date = new Date(inputDate);

        // Filter objects where the applicable date is >= provided date
        const applicableObj = data
            .filter(item => new Date(item.applicable_till_date) >= date)
            .sort((a, b) => new Date(a.applicable_till_date) - new Date(b.applicable_till_date))[0];

        if (!applicableObj) return null;

        // Salary check
        return salary > 2000
            ? parseFloat(applicableObj.charges_above).toFixed(2)
            : parseFloat(applicableObj.charges_below).toFixed(2);
    }

    const safeNumber = (value) => {
        const number = Number.parseFloat(value);
        return Number.isFinite(number) ? number : 0;
    };

    const getOverstayCharges = (overstayDays, overstayRate) => {
        const calculatedCharges = Number(overstayDays) * Number(overstayRate || 0);
        return Math.max(0, calculatedCharges || 0);
    }

    // Overstay days inside the billed month [monthStart, monthEnd]:
    // starts 30 days (grace) after the visa expiry and stops the day before the visa was renewed.
    // Valid visas, cancelled (exited / status changed) and absconded candidates have no overstay.
    const OVERSTAY_GRACE_DAYS = 30;
    const computeOverstayDays = (item, monthStart, monthEnd) => {
        if (!item?.visa_expiry) return 0;

        const processings = Array.isArray(item?.processings) ? item.processings : [];
        const isClosedCancel = (value) => {
            const normalized = (value || "").toString().toLowerCase().trim();
            return normalized.startsWith("canceled-") || normalized.startsWith("cancelled-");
        };
        const isClosed = processings.some(proc => {
            const type = proc?.type?.toLowerCase();
            const last = proc?.last_status?.toLowerCase() || "";
            if (type === "cancel") return isClosedCancel(proc?.last_status) || proc?.statuses?.some(st => isClosedCancel(st?.status));
            if (type === "absconder") return last.includes("abscond");
            return false;
        });
        if (isClosed || isClosedCancel(item?.last_status)) return 0;

        let expiry = moment(item.visa_expiry).startOf("day");
        let overstayEnd = monthEnd.clone().startOf("day");

        const renewedRequest = [...processings]
            .sort((a, b) => b.id - a.id)
            .find(proc => proc?.type?.toLowerCase() === "renew" && proc?.statuses?.some(st => st?.status === "Renewed"));
        const renewedStatus = renewedRequest?.statuses?.find(st => st?.status === "Renewed");

        if (renewedStatus?.date) {
            const renewedOn = moment(renewedStatus.date).startOf("day");
            if (renewedOn.isAfter(monthEnd)) {
                // Renewed after the billed month: the old expiry applied during this month
                const years = (item?.visa_tenure || "").includes("2") ? 2 : 1;
                expiry = moment(item.visa_expiry).subtract(years, "year").startOf("day");
            } else {
                const years = (item?.visa_tenure || "").includes("2") ? 2 : 1;
                const oldExpiry = moment(renewedStatus.new_expiry_date || item.visa_expiry).subtract(years, "year").startOf("day");
                if (renewedOn.isBefore(monthStart)) {
                    // Renewed before this month: current (new) expiry applies
                    expiry = moment(item.visa_expiry).startOf("day");
                } else {
                    // Renewed during this month: overstay only until the day before renewal
                    expiry = oldExpiry;
                    overstayEnd = renewedOn.clone().subtract(1, "day");
                }
            }
        }

        const overstayStart = moment.max(expiry.clone().add(OVERSTAY_GRACE_DAYS, "days"), monthStart.clone().startOf("day"));
        if (overstayEnd.isBefore(overstayStart)) return 0;
        return overstayEnd.diff(overstayStart, "days") + 1;
    };

    const getCandidateInvoiceTotals = (item, overstayRate = 0) => {
        const serviceCharges = safeNumber(item?.applicableVisaCharges);
        const overstayCharges = getOverstayCharges(item?.overstayDays, overstayRate);
        const totalAmount = serviceCharges + overstayCharges;

        return {
            serviceCharges,
            overstayCharges,
            totalAmount,
        };
    };


    const PaginationFunc = (data, pg = 1) => {
        if (!data) {
            data = totalData
        }
        startIndex = (pg - 1) * itemsPerPage;
        endIndex = startIndex + itemsPerPage;
        // console.log(startIndex, 'displayedItems');
        // console.log(endIndex, 'displayedItems');
        // console.log(data, 'displayedItems');
        setOriginalArray(data, 'displayedItemsdisplayedItemsdisplayedItemsdisplayedItems')
        displayedItems = data?.slice(startIndex, endIndex);
        // console.log(displayedItems, 'displayedItems2');

        setCandidates(displayedItems)

        if (selectAll) {
            console.log(deselectedArray, 'deselectedArray');

            const filteredItems = totalData.filter(
                (item) => !deselectedArray.some((deselected) => deselected.id === item.id)
            );
            setSelectedRows(filteredItems.filter(item => item.applicableVisaCharges > 0));

        }
        if (searchVal) {

            handleSearchChange(displayedItems, searchVal)
        }
        // console.log(displayedItems, 'displayedItems3');
    }

    const handleCheckboxChange = (item, isChecked) => {
        if (isChecked) {

            setSelectedRows([...selectedRows, item]);
            setDeselectedArray(deselectedArray.filter(item2 => item2?.id != item?.id))
        } else {
            // Remove the item from the selectedRows state
            setSelectedRows(selectedRows.filter(row => row?.id !== item?.id));
            let deselectedElement = candidates.find(item2 => item2?.id == item?.id)
            console.log(deselectedElement);

            console.log([...deselectedArray, deselectedElement], 'deselectedArray');

            setDeselectedArray([...deselectedArray, deselectedElement])
        }
    };
    const handleCheckboxChange2 = (isChecked) => {
        console.log(isChecked, 'isChecked');

        setSelectAll(isChecked)
        if (isChecked) {
            console.log(candidates.filter(item => item.applicableVisaCharges > 0));

            setSelectedRows(originalArray.filter(item => item.applicableVisaCharges > 0));

        } else {
            setSelectedRows([]);
        }
    };

    const getData = async (formData) => {

        console.log(formData);
        try {
            let params = {
                charges_type: 'rate'

            }

            const { data } = await SystemServices.getRates(params);

            let details = data?.charges
            setCharges(details)



        } catch (error) {

        } finally {

        }
    }

    const CreateMonthlyInvoice = async (formData) => {

        console.log(selectedRows, 'selectedRows');
        const transformedData = selectedRows.map(item => {
            const { serviceCharges, overstayCharges, totalAmount } = getCandidateInvoiceTotals(item, charges?.overstay);

            return {
                candidate_id: item.id,
                total_amount: Number(totalAmount.toFixed(2)),
                service_charges: Number(serviceCharges.toFixed(2)),
                overstay_charges: Number(overstayCharges.toFixed(2)),
                overstay_days: item.overstayDays ? Number(item.overstayDays) : 0,
            };
        });

        console.log(transformedData, 'transformedDatatransformedData');
        const total = selectedRows.reduce((sum, item) => {
            const { totalAmount } = getCandidateInvoiceTotals(item, charges?.overstay);
            return sum + totalAmount;
        }, 0);

        if (transformedData.some(item => Number(item.total_amount) === 0)) {
            showErrorToast('candidate has a total amount of 0');
        }
        else {

            try {

                let obj = {
                    customer_id: selectedCustomer?.id,
                    total_amount: total,
                    due_date: null,
                    tax: parseFloat(total) * 0.05,
                    month_year: moment(selectMonth).isValid() ? moment(selectMonth).format("MMMM-YYYY") : moment().format("MMMM-YYYY"),
                    billing_month: moment(selectMonth).isValid() ? moment(selectMonth).subtract(1, "month").format("MMMM-YYYY") : moment().subtract(1, "month").format("MMMM-YYYY"),

                    candidates: transformedData
                };

                console.log(obj, 'obj');

                const promise = InvoiceServices.CreateMonthlyInvoice(obj);
                //const promise = null;

                showPromiseToast(
                    promise,
                    'Saving...',
                    'Added Successfully',
                    'Something Went Wrong'
                );

                const response = await promise;
                if (response?.responseCode === 200) {
                    navigate("/monthly-invoices");
                    getCandidateList()
                }


            } catch (error) {
                console.log(error);
            }
        }
    };
    // *For Get Customer Queue

    const getCustomerQueue = async (page, limit, filter) => {
        // setLoader(true)
        try {

            let params = {
                page: 1,
                limit: 1000,
            }
            params = { ...params }
            const { data } = await CustomerServices.getCustomerQueue(params)
            console.log(user);

            if (user?.user_type == 'C') {
                console.log(customerQueue);
                let currentUser = data?.rows?.find(item => item?.id == user?.customer_id)
                console.log(currentUser);
                setSelectedCustomer(currentUser)
                setValue('customer', currentUser)

            }


            setCustomerQueue(data?.rows)

        } catch (error) {
            showErrorToast(error)
        } finally {
            // setLoader(false)
        }
    }
    const getCandidateList = async (page, limit, filter, id, date, salaryChargeData) => {
        const customerId = id || selectedCustomer?.id;

        if (!customerId) {
            setCandidates([]);
            setTotalData([]);
            setOriginalArray([]);
            setSelectedRows([]);
            setTotalCount(0);
            setTotalCandidateCount(0);
            return;
        }

        console.log(date, 'selectedMonth');
        setLoader(true)

        try {
            const ourCurrentDate = date ? moment(date) : moment(); // <<<<<< GLOBAL REPLACEMENT VARIABLE
            console.log(selectMonth, date, 'selectMonth');
            const applicableSalaryCharges = salaryChargeData || salaryCharges;

            const Page = page || currentPage;
            const Limit = 999;
            const Filter = { ...filters, ...filter };
            setCurrentPage(Page);
            setPageLimit(Limit);
            setFilters(Filter);

            let params = {
                page: Page,
                limit: Limit,
                customer_id: customerId,
                date: date
                    ? moment(date).format("MMMM-YYYY")
                    : moment(selectMonth).format("MMMM-YYYY"),



            };
            params = { ...params, ...Filter };

            const { data } = await InvoiceServices.getCanidateList(params);

            const apiCount = Number(data?.count ?? data?.totalCount ?? data?.total ?? data?.rows?.length ?? 0);
            setTotalCandidateCount(apiCount);

            const candidatesWithCharges = data?.rows?.map(item => {
                let additionalDays = 0;
                const customer = item?.customer;
                let overstayDays = 0;
                let cancelledEffectiveDate = null;
                let absconderEffectiveDate = null;

                if (item?.visa_expiry) {
                    // console.log("yaha agia", item);

                    let visaExpiry = moment(item?.visa_expiry); // KEEP AS IS
                    let lastMonthEndDate = ourCurrentDate.clone().subtract(1, "month").endOf("month").endOf("day");
                    let expiryAfterGrace = visaExpiry.clone().startOf("day").add(30, "days");
                    let newOverstayDays = ourCurrentDate.clone().startOf("day").diff(expiryAfterGrace, "days");

                    if (newOverstayDays > 0) {
                        overstayDays = newOverstayDays;
                    }

                    let differenceInMonths = parseInt(ourCurrentDate.clone().subtract(1, "month").format("MM"))
                        - parseInt(expiryAfterGrace.format("MM"));

                    if (visaExpiry.isAfter(ourCurrentDate)) {
                        differenceInMonths = -1;
                    }
                    if (differenceInMonths > 0) {
                        overstayDays = lastMonthEndDate.format("DD");
                    }
                    else if (differenceInMonths == 0) {

                        if (parseInt(lastMonthEndDate.format("DD")) === parseInt(expiryAfterGrace.format("DD"))) {
                            overstayDays = parseInt(lastMonthEndDate.format("DD")) - parseInt(expiryAfterGrace.format("DD"));
                        } else {
                            overstayDays = (parseInt(lastMonthEndDate.format("DD")) - parseInt(expiryAfterGrace.format("DD"))) + 1;
                        }

                        if (parseInt(expiryAfterGrace.format("YYYY")) < parseInt(ourCurrentDate.format("YYYY"))) {
                            overstayDays = lastMonthEndDate.format("DD");
                        }

                    } else {
                        overstayDays = 0;
                    }

                    let sortedData = item.processings;
                    if (sortedData.length > 0) {
                        sortedData = item.processings.sort((a, b) => b.id - a.id);
                    }

                    if (sortedData.length > 0) {

                        let renewed = {};
                        if (item?.last_status) {
                            renewed = sortedData.find(item =>
                                item?.last_status?.toLowerCase() === "renewed" &&
                                item?.type?.toLowerCase() === "renew"
                            );
                        }

                        if (renewed) {
                            const sortedStatuses = renewed?.statuses?.sort((a, b) => b.id - a.id);
                            const renewedDate = sortedStatuses?.find(item => item.status == "Renewed");

                            if (renewedDate) {
                                let oldExpiryDate = visaExpiry.clone();

                                if (item?.visa_tenure.includes("2")) {
                                    oldExpiryDate = moment(item?.visa_expiry).subtract(2, "year");
                                } else {
                                    oldExpiryDate = moment(item?.visa_expiry).subtract(1, "year");
                                }

                                expiryAfterGrace = oldExpiryDate.clone().startOf("day").add(30, "days");

                                differenceInMonths =
                                    parseInt(ourCurrentDate.clone().subtract(1, "month").format("MM"))
                                    - parseInt(expiryAfterGrace.format("MM"));

                                if (oldExpiryDate.format("YYYY") !== ourCurrentDate.format("YYYY")) {
                                    differenceInMonths = -99999;
                                }

                                if (differenceInMonths > 0) {
                                    overstayDays = lastMonthEndDate.format("DD");
                                }
                                else if (differenceInMonths == 0 &&
                                    oldExpiryDate.format("YYYY") == ourCurrentDate.format("YYYY")) {

                                    let renewDate = moment(renewedDate.date);

                                    if (parseInt(renewDate.format("DD")) === parseInt(expiryAfterGrace.format("DD"))) {
                                        overstayDays = 0;
                                    } else {
                                        overstayDays =
                                            (parseInt(renewDate.format("DD")) - parseInt(expiryAfterGrace.format("DD"))) + 1;
                                    }

                                    if (
                                        parseInt(expiryAfterGrace.format("YYYY")) < parseInt(ourCurrentDate.format("YYYY")) &&
                                        parseInt(renewDate.format("YYYY")) !== parseInt(ourCurrentDate.format("YYYY"))
                                    ) {
                                        overstayDays = lastMonthEndDate.format("DD");
                                    }

                                }
                                else if (differenceInMonths == -99999 &&
                                    moment(renewedDate.date) <= lastMonthEndDate
                                ) {
                                    let renewDate = moment(renewedDate.date);
                                    overstayDays = parseInt(renewDate.format("DD"));
                                }
                                else {
                                    overstayDays = 0;
                                }
                            }
                        }

                        const isCancelledStatus = (value) => {
                            const normalized = (value || "").toString().toLowerCase().trim();
                            return (
                                normalized === "canceled-exited" ||
                                normalized === "canceled-status changed" ||
                                normalized === "cancelled-exited" ||
                                normalized === "cancelled-status changed"
                            );
                        };

                        let cancelled = null;
                        
                        if (Array.isArray(sortedData) && sortedData.length > 0) {
                            cancelled = sortedData.find(proc =>
                                proc?.type?.toLowerCase() === "cancel" && (
                                    isCancelledStatus(proc?.last_status) ||
                                    proc?.statuses?.some(st =>
                                        isCancelledStatus(st?.status) || isCancelledStatus(st?.last_status)
                                    )
                                )
                            );

                           

                            if (!cancelled && isCancelledStatus(item?.last_status)) {
                                cancelled =
                                    sortedData.find(proc => proc?.type?.toLowerCase() === "cancel") ||
                                    sortedData.find(proc =>
                                        proc?.statuses?.some(st =>
                                            isCancelledStatus(st?.status) || isCancelledStatus(st?.last_status)
                                        )
                                    ) ||
                                    null;
                            }
                        }

                        if (cancelled || isCancelledStatus(item?.last_status)) {
                            const cancelStartDate =
                                cancelled?.statuses?.find(st => (
                                    isCancelledStatus(st?.status) || isCancelledStatus(st?.last_status)
                                )) ||
                                item?.statuses?.find(st => (
                                    isCancelledStatus(st?.status) || isCancelledStatus(st?.last_status)
                                ));

                            const cancellationRawDate =
                                cancelStartDate?.date ||
                                cancelStartDate?.created_at ||
                                item?.monthly_service_cancelled_date ||
                                item?.monthly_charges_cancelled_date ||
                                item?.cancelled_date ||
                                item?.canceled_date;

                            let newDays = cancellationRawDate
                                ? moment(cancellationRawDate).clone().startOf('day')
                                : null;

                            if (newDays?.isValid()) {
                                cancelledEffectiveDate = newDays.clone();
                            }

                            if (!newDays || !newDays.isValid()) {
                                newDays = null;
                            }

                            if (!newDays) {
                                overstayDays = 0;
                            } else {

                                let newDaysMonth = parseInt(newDays.format("MM"));
                                let lastMonthDays = parseInt(lastMonthEndDate.format("MM"));
                                newOverstayDays = lastMonthEndDate.diff(newDays, "days");

                                if (newOverstayDays > 0) {
                                    overstayDays = newOverstayDays;
                                }

                                if (!newDays.isAfter(lastMonthEndDate)) {
                                    if (lastMonthDays - newDaysMonth > 0) {
                                        const cancelEndDateObj =
                                            cancelled?.statuses?.find(st =>
                                                isCancelledStatus(st?.status) || isCancelledStatus(st?.last_status)
                                            );

                                        if (cancelEndDateObj) {
                                            let cancelEndDate = moment(cancelEndDateObj.date);

                                            let differenceInEndDate =
                                                parseInt(lastMonthEndDate.format("MM")) -
                                                parseInt(cancelEndDate.format("MM"));

                                            overstayDays = lastMonthEndDate.format("DD");

                                            if (differenceInEndDate == 0) {
                                                overstayDays = parseInt(cancelEndDate.startOf("day").format("DD"));
                                            }

                                        } else {
                                            overstayDays = parseInt(lastMonthEndDate.startOf("day").format("DD"));
                                        }

                                    }
                                    else if (lastMonthDays - newDaysMonth == 0) {
                                        const cancelEndDateObj =
                                            cancelled?.statuses?.find(st =>
                                                isCancelledStatus(st?.status) || isCancelledStatus(st?.last_status)
                                            );

                                        if (cancelEndDateObj) {
                                            let cancelEndDate = moment(cancelEndDateObj.date);

                                            if (
                                                parseInt(cancelEndDate.startOf("day").format("DD")) ===
                                                parseInt(newDays.format("DD"))
                                            ) {
                                                overstayDays = 0;
                                            } else {
                                                overstayDays =
                                                    (parseInt(cancelEndDate.startOf("day").format("DD")) -
                                                        parseInt(newDays.format("DD"))) + 1;
                                            }
                                        } else {
                                            if (
                                                parseInt(lastMonthEndDate.startOf("day").format("DD")) ===
                                                parseInt(newDays.format("DD"))
                                            ) {
                                                overstayDays = 0;
                                            } else {
                                                overstayDays =
                                                    (parseInt(lastMonthEndDate.startOf("day").format("DD")) -
                                                        parseInt(newDays.format("DD"))) + 1;
                                            }
                                        }

                                    }

                                    else {
                                        overstayDays = 0;
                                    }
                                }
                            }

                        }

                        // ── Absconder pro-rata logic ──────────────────────────────────────
                        // Applies when a processing entry has type "Absconder" and
                        // last_status of "absconded" or "absconder", AND the effective
                        // absconder date falls within the invoice month (expiring this month).
                        if (!cancelled) {
                            let absconder = null;
                            if (item?.last_status) {
                                absconder = sortedData.find(proc =>
                                    (
                                        proc?.last_status?.toLowerCase() === "absconded" ||
                                        proc?.last_status?.toLowerCase() === "absconder"
                                    ) &&
                                    proc?.type?.toLowerCase() === "absconder"
                                );
                            }

                            if (absconder) {
                                const absconderStatusEntry =
                                    absconder?.statuses?.find(s => (
                                        s?.status?.toLowerCase() === "absconded" ||
                                        s?.status?.toLowerCase() === "absconder"
                                    ));

                                let absconderDate = absconderStatusEntry?.date
                                    ? moment(absconderStatusEntry.date).clone().startOf('day')
                                    : null;

                                if (absconderDate?.isValid()) {
                                    // Only apply pro-rata if the absconder date falls
                                    // within the previous (invoice) month — i.e. "expiring this month"
                                    const prevMonthStart = lastMonthEndDate.clone().startOf('month');
                                    const prevMonthEnd   = lastMonthEndDate.clone().endOf('month').endOf('day');

                                    if (absconderDate.isBetween(prevMonthStart, prevMonthEnd, 'day', '[]')) {
                                        absconderEffectiveDate = absconderDate.clone();
                                        console.log("Absconder effective date (this invoice month):", absconderEffectiveDate.format("YYYY-MM-DD"));
                                    } else {
                                        console.log("Absconder date outside invoice month — no pro-rata cap applied.");
                                    }
                                }
                            }
                        }
                        // ─────────────────────────────────────────────────────────────────
                    }
                }

                if (!item?.visa_expiry) {
                    const lastMonthEndDate = ourCurrentDate.clone().subtract(1, "month").endOf("month").endOf("day");
                    let sortedData = Array.isArray(item?.processings) ? [...item.processings] : [];

                    if (sortedData.length > 0) {
                        sortedData = sortedData.sort((a, b) => b.id - a.id);
                    }

                    if (sortedData.length > 0) {
                        const isCancelledStatus = (value) => {
                            const normalized = (value || "").toString().toLowerCase().trim();
                            return (
                                normalized === "canceled-exited" ||
                                normalized === "canceled-status changed" ||
                                normalized === "cancelled-exited" ||
                                normalized === "cancelled-status changed"
                            );
                        };

                        let cancelled = null;

                        cancelled = sortedData.find(proc =>
                            proc?.type?.toLowerCase() === "cancel" && (
                                isCancelledStatus(proc?.last_status) ||
                                proc?.statuses?.some(st =>
                                    isCancelledStatus(st?.status) || isCancelledStatus(st?.last_status)
                                )
                            )
                        );

                        if (!cancelled && isCancelledStatus(item?.last_status)) {
                            cancelled =
                                sortedData.find(proc => proc?.type?.toLowerCase() === "cancel") ||
                                sortedData.find(proc =>
                                    proc?.statuses?.some(st =>
                                        isCancelledStatus(st?.status) || isCancelledStatus(st?.last_status)
                                    )
                                ) ||
                                null;
                        }

                        if (cancelled || isCancelledStatus(item?.last_status)) {
                            const cancelStartDate =
                                cancelled?.statuses?.find(st => (
                                    isCancelledStatus(st?.status) || isCancelledStatus(st?.last_status)
                                )) ||
                                item?.statuses?.find(st => (
                                    isCancelledStatus(st?.status) || isCancelledStatus(st?.last_status)
                                ));

                            const cancellationRawDate =
                                cancelStartDate?.date ||
                                cancelStartDate?.created_at ||
                                item?.monthly_service_cancelled_date ||
                                item?.monthly_charges_cancelled_date ||
                                item?.cancelled_date ||
                                item?.canceled_date;

                            const newDays = cancellationRawDate
                                ? moment(cancellationRawDate).clone().startOf('day')
                                : null;

                            if (newDays?.isValid()) {
                                cancelledEffectiveDate = newDays.clone();
                            }
                        }

                        if (!cancelled) {
                            const absconder = sortedData.find(proc =>
                                (
                                    proc?.last_status?.toLowerCase() === "absconded" ||
                                    proc?.last_status?.toLowerCase() === "absconder"
                                ) &&
                                proc?.type?.toLowerCase() === "absconder"
                            );

                            if (absconder) {
                                const absconderStatusEntry =
                                    absconder?.statuses?.find(s => (
                                        s?.status?.toLowerCase() === "absconded" ||
                                        s?.status?.toLowerCase() === "absconder"
                                    ));

                                const absconderDate = absconderStatusEntry?.date
                                    ? moment(absconderStatusEntry.date).clone().startOf('day')
                                    : null;

                                if (absconderDate?.isValid()) {
                                    const prevMonthStart = lastMonthEndDate.clone().startOf('month');
                                    const prevMonthEnd = lastMonthEndDate.clone().endOf('month').endOf('day');

                                    if (absconderDate.isBetween(prevMonthStart, prevMonthEnd, 'day', '[]')) {
                                        absconderEffectiveDate = absconderDate.clone();
                                    }
                                }
                            }
                        }
                    }
                }

                // Single source of truth for overstay (overrides the older month-number comparisons above)
                {
                    const billedMonthEnd = ourCurrentDate.clone().subtract(1, "month").endOf("month");
                    overstayDays = computeOverstayDays(item, billedMonthEnd.clone().startOf("month"), billedMonthEnd);
                }

                if (customer.due_date_policy?.includes("7")) additionalDays = 7;
                else if (customer.due_date_policy?.includes("15")) additionalDays = 15;
                else if (customer.due_date_policy?.includes("20")) additionalDays = 20;
                else if (customer.due_date_policy?.includes("25")) additionalDays = 25;
                else if (customer.due_date_policy?.includes("30")) additionalDays = 30;
                else if (customer.due_date_policy?.includes("60")) additionalDays = 60;
                else if (customer.due_date_policy?.includes("90")) additionalDays = 90;

                let targetStatus =
                    item?.statuses?.find(status =>
                        status?.status === 'Entry Permit' || status?.status === 'Change Status'
                    );

                let targetDate = moment(item?.change_status_date).add(additionalDays, "d");

                let previousMonth =
                    ourCurrentDate.clone().startOf("month").startOf("day").subtract(1, "month");

                let previousMonthNumber = previousMonth.format("MM");
                let targetDateNumber = targetDate.format("MM");

                let differenceMonth =
                    parseInt(previousMonthNumber) - parseInt(targetDateNumber);

         console.log("differenceMonth:", differenceMonth);

let monthDifference = differenceMonth;
console.log("monthDifference:", monthDifference);

let remainingDays = 0;
console.log("initial remainingDays:", remainingDays);

let totalDaysInPrevMonth = previousMonth
  .clone()
  .endOf("month")
  .format("DD");

console.log("totalDaysInPrevMonth:", totalDaysInPrevMonth);

if (monthDifference === 0) {
  console.log("CASE: monthDifference === 0");

  let totalDaysInTarget = targetDate.format("DD");
  console.log("totalDaysInTarget:", totalDaysInTarget);

  remainingDays =
    parseInt(totalDaysInPrevMonth) -
    parseInt(totalDaysInTarget) +
    1;

  console.log("remainingDays after calc:", remainingDays);

  console.log(
    "targetYear:",
    targetDate.format("YYYY"),
    "currentYear:",
    ourCurrentDate.format("YYYY")
  );

  if (
    parseInt(targetDate.format("YYYY")) <
    parseInt(ourCurrentDate.format("YYYY"))
  ) {
    remainingDays = totalDaysInPrevMonth;
    console.log(
      "Target year < current year → remainingDays reset:",
      remainingDays
    );
  }

} else if (monthDifference > 0) {
  console.log("CASE: monthDifference > 0");

  remainingDays = parseInt(totalDaysInPrevMonth);
  console.log("remainingDays:", remainingDays);

} else {
  console.log("CASE: monthDifference < 0");

  console.log(
    "targetYear:",
    targetDate.format("YYYY"),
    "currentYear:",
    ourCurrentDate.format("YYYY")
  );

  if (
    parseInt(targetDate.format("YYYY")) <
    parseInt(ourCurrentDate.format("YYYY"))
  ) {
    remainingDays = totalDaysInPrevMonth;
    console.log(
      "Target year < current year → remainingDays:",
      remainingDays
    );
  }
}

console.log("FINAL remainingDays:", remainingDays);

                const previousMonthEnd = previousMonth.clone().endOf("month").endOf("day");

                // Days billed are counted from the billing start day (day 1, or the entry permit / change status day)
                // up to and including the stop day -- not the day-of-month of the stop date
                const capRemainingDays = (days, stopDate) => {
                    const billedDays = parseInt(days) || 0;
                    if (billedDays <= 0) return 0;
                    const startDay = parseInt(totalDaysInPrevMonth) - billedDays + 1;
                    return Math.max(0, Math.min(billedDays, parseInt(stopDate.format("DD")) - startDay + 1));
                };

                if (
                    cancelledEffectiveDate?.isValid() &&
                    cancelledEffectiveDate.isBetween(previousMonth, previousMonthEnd, "day", "[]")
                ) {
                    remainingDays = capRemainingDays(remainingDays, cancelledEffectiveDate);
                    console.log("remainingDays after cancellation cap:", remainingDays);
                }

                // Absconder pro-rata cap: if absconder date falls in invoice month,
                // charge only up to (and including) that day — same logic as cancelled.
                if (
                    absconderEffectiveDate?.isValid() &&
                    absconderEffectiveDate.isBetween(previousMonth, previousMonthEnd, "day", "[]")
                ) {
                    remainingDays = capRemainingDays(remainingDays, absconderEffectiveDate);
                    console.log("remainingDays after absconder cap:", remainingDays);
                }

                // Monthly charges stopped on the candidate itself (Reject / Cancel / Absconder at VR stage,
                // Exited / Status Changed): charge only up to that date, nothing when it is before the invoice month
                const chargesStoppedDate = item?.monthly_charges_cancelled && item?.monthly_charges_cancelled_date
                    ? moment(item.monthly_charges_cancelled_date).startOf("day")
                    : null;
                if (chargesStoppedDate?.isValid()) {
                    if (chargesStoppedDate.isBefore(previousMonth, "day")) {
                        remainingDays = 0;
                    } else if (chargesStoppedDate.isBetween(previousMonth, previousMonthEnd, "day", "[]")) {
                        remainingDays = capRemainingDays(remainingDays, chargesStoppedDate);
                    }
                }

                console.log(salaryCharges, item?.change_status_date, parseFloat(item?.salary_total), 'totalVisaCharges');

                let totalVisaCharges =
                    getApplicableCharge(
                        applicableSalaryCharges,
                        item?.change_status_date,
                        parseFloat(item?.salary_total)
                    );

                console.log("salaryCharges:", salaryCharges);
                console.log("change_status_date:", item?.change_status_date);
                console.log("salary_total:", item?.salary_total);
                console.log("totalVisaCharges:", totalVisaCharges);

                let perDayVisaCharges = totalVisaCharges / parseInt(totalDaysInPrevMonth);

                console.log("totalDaysInPrevMonth:", totalDaysInPrevMonth);
                console.log("perDayVisaCharges:", perDayVisaCharges);

                let applicableVisaCharges = remainingDays * perDayVisaCharges;

                console.log("remainingDays:", remainingDays);
                console.log("applicableVisaCharges:", applicableVisaCharges);


                return {
                    ...item,
                    applicableVisaCharges,
                    overstayDays
                };
            });

            // Sort candidates: first by applicableVisaCharges (0 first), then by id ascending
            const sortedCandidates = candidatesWithCharges.sort((a, b) => {
                // Prioritize non-zero charges first
                if ((a.applicableVisaCharges === 0) !== (b.applicableVisaCharges === 0)) {
                    return a.applicableVisaCharges === 0 ? 1 : -1;
                }
                // Otherwise, sort by id in ascending order
                return a.id - b.id;
            });

            if (selectAll) {
                setSelectedRows(sortedCandidates.filter(item => item.applicableVisaCharges > 0));
            }

            setTotalData(sortedCandidates);
            setCandidates(sortedCandidates);
            setOriginalArray(sortedCandidates);
            PaginationFunc(sortedCandidates, 1);
            setTotalCount(Math.ceil(sortedCandidates?.length / itemsPerPage));

        } catch (error) {
            showErrorToast(error);
        } finally {
  setLoader(false)
        }
    };

    const handleSearchChange = (items, value) => {

        setSearchVal(value)
        const value1 = value.toLowerCase();
        // console.log(value1);
        let array = Array.isArray(items) ? items : originalArray
        // console.log(items, 'array');
        // console.log(array, 'array');

        if (value1) {

            const updatedData = array.filter((item) =>
                Object.values(item).some((field) =>
                    typeof field === 'string' || typeof field === 'number'
                        ? field.toString().toLowerCase().includes(value1.toLowerCase())
                        : false
                )
            );

            setCandidates(updatedData);

        }
        else {
            setCandidates(originalArray);
        }



    };
    const [selectMonth, setSelectMonth] = useState(new Date());
    const handleSelectMonth = async (newDate) => {
        try {
            console.log(newDate, 'newDate');

            // eslint-disable-next-line eqeqeq
            if (newDate == "Invalid Date") {
                setSelectMonth("invalid");
                return;
            }
            const selectedMonth = new Date(newDate);
            console.log(selectedMonth, 'selectedMonth');

            setSelectMonth(selectedMonth);
            // Update form field value for react-hook-form validation
            setValue("month", selectedMonth);

            if (!selectedCustomer?.id) {
                return;
            }
            
            // --- Wait for charges to finish ---
            const chargesData = await getCharges(selectedCustomer?.id);
            getCandidateList(null, null, null, selectedCustomer?.id, selectedMonth, chargesData)
        } catch (error) {
            ErrorToaster(error);
        }
    };
    // *For Handle Filter
    const handleFilter = () => {
        let data = {
            search: getValues('search')
        }
        Debounce(() => getCandidateList(1, '', data));
    }

    const handleSort = (key) => {
        let data = {
            sort_by: key,
            sort_order: sort
        }
        Debounce(() => getCandidateList(1, '', data));
    }

    const downloadMonthlyInvoicesExcel = async (invoiceData) => {
        const ExcelJS = require("exceljs")
        const { saveAs } = require("file-saver")

        const workbook = new ExcelJS.Workbook()
        const worksheet = workbook.addWorksheet("Monthly Invoices")

        // Set professional header and footer
        worksheet.headerFooter.oddHeader =
            '&C&"Arial,Bold"&18MONTHLY INVOICES DRAFT\n' +
            '&C&"Arial,Regular"&12Your Company Name\n' +
            '&C&"Arial,Regular"&10Generated: &D\n' +
            '&L&"Arial,Regular"&8Generated on: ' +
            new Date().toLocaleDateString() +
            "\n" +
            '&R&"Arial,Regular"&8Page &P of &N'

        worksheet.headerFooter.oddFooter =
            '&L&"Arial,Regular"&8Confidential - Internal Use Only' +
            '&C&"Arial,Regular"&8This report contains financial data as of ' +
            new Date().toLocaleDateString() +
            '&R&"Arial,Regular"&8Generated by: Finance Department\n' +
            '&C&"Arial,Regular"&8Powered by Premium Business Solutions'

        worksheet.headerFooter.evenFooter = worksheet.headerFooter.oddFooter

        // Set page setup for professional printing
        worksheet.pageSetup = {
            paperSize: 9, // A4
            orientation: "landscape",
            fitToPage: true,
            fitToWidth: 1,
            fitToHeight: 0,
            margins: {
                left: 0.7,
                right: 0.7,
                top: 1.0,
                bottom: 1.0,
                header: 0.3,
                footer: 0.3,
            },
        }

        // Add title section
        const titleRow = worksheet.addRow(["MONTHLY INVOICES DRAFT"])
        titleRow.getCell(1).font = {
            name: "Arial",
            size: 16,
            bold: true,
            color: { argb: "2F4F4F" },
        }
        titleRow.getCell(1).alignment = { horizontal: "center" }
        worksheet.mergeCells("A1:F1")

        const companyRow = worksheet.addRow(["MABDE TRADING LLC"])
        companyRow.getCell(1).font = {
            name: "Arial",
            size: 14,
            bold: true,
            color: { argb: "4472C4" },
        }
        companyRow.getCell(1).alignment = { horizontal: "center" }
        worksheet.mergeCells("A2:F2")

        const dateRow = worksheet.addRow([
            `Report Generated: ${new Date().toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            })} at ${new Date().toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
            })}`,
        ])
        dateRow.getCell(1).font = {
            name: "Arial",
            size: 10,
            italic: true,
            color: { argb: "666666" },
        }
        dateRow.getCell(1).alignment = { horizontal: "center" }
        worksheet.mergeCells("A3:F3")

        // Add empty row for spacing
        worksheet.addRow([])

        // Define column headers
        const headers = [
            "Candidate Name",
            "Customer Name",
            "Passport Number",
            "Monthly Service Charge",
            "Applicable Service Charges",
            "Overstay Charges",
            "Total Amount",
        ]

        const headerRow = worksheet.addRow(headers)
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "808080" }, // Gray
            }
            cell.font = { bold: true, color: { argb: "FFFFFF" } } // White bold
        })

        // Initialize totals
        let totalServiceCharge = 0
        let totalVisaCharges = 0
        let totalOverstayCharges = 0
        let totalAmount = 0

        // Add data rows
        if (invoiceData && invoiceData.length > 0) {
            invoiceData.forEach((item) => {
                const monthlyServiceCharge = safeNumber(getApplicableCharge(salaryCharges, item?.change_status_date, parseFloat(item?.salary_total)))
                const { serviceCharges, overstayCharges, totalAmount: rowTotalAmount } = getCandidateInvoiceTotals(item, charges?.overstay || item?.charges?.overstay)

                const applicableVisaCharges = serviceCharges
                const rowTotal = rowTotalAmount

                const row = worksheet.addRow([
                    item?.name || "",
                    item?.customer?.name || "",
                    item?.passport_number || "",
                    monthlyServiceCharge,
                    applicableVisaCharges,
                    overstayCharges,
                    rowTotal,
                ])

                // Format numerical columns as numbers with 2 decimal places
                for (let i = 3; i <= 6; i++) {
                    row.getCell(i).numFmt = "#,##0.00"
                }

                // Update totals
                totalServiceCharge += monthlyServiceCharge
                totalVisaCharges += applicableVisaCharges
                totalOverstayCharges += overstayCharges
                totalAmount += rowTotal
            })
        }

        setExcelJsAutoFilter(worksheet, headerRow, worksheet.lastRow.number, headers.length)

        // Add empty row before totals
        worksheet.addRow([])

        // Add Grand Total row
        const totalRow = worksheet.addRow([
            "TOTAL",
            "",
            "",
            totalServiceCharge,
            totalVisaCharges,
            totalOverstayCharges,
            totalAmount,
        ])

        // Format numerical columns
        for (let i = 3; i <= 6; i++) {
            totalRow.getCell(i).numFmt = "#,##0.00"
        }

        totalRow.eachCell((cell) => {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "000000" }, // Black
            }
            cell.font = { bold: true, color: { argb: "FFFFFF" } } // White bold
        })

        // Add empty rows for spacing
        worksheet.addRow([])
        worksheet.addRow([])

        // Add generated report text
        const reportRow = worksheet.addRow(["This is electronically generated report"])
        reportRow.getCell(1).font = {
            name: "Arial",
            size: 12,
            bold: false,
            color: { argb: "000000" },
        }
        reportRow.getCell(1).alignment = { horizontal: "center", vertical: "middle" }
        reportRow.getCell(1).border = {
            top: { style: "medium", color: { argb: "000000" } },
            left: { style: "medium", color: { argb: "000000" } },
            bottom: { style: "medium", color: { argb: "000000" } },
            right: { style: "medium", color: { argb: "000000" } },
        }
        worksheet.mergeCells(`A${reportRow.number}:F${reportRow.number}`)

        // Set column widths
        worksheet.columns = [{ width: 20 }, { width: 25 }, { width: 20 }, { width: 22 }, { width: 18 }, { width: 16 }, { width: 18 }]

        // Add footer
        const system = worksheet.addRow([`Powered By: MangotechDevs.ae`])
        system.getCell(1).font = {
            name: "Arial",
            size: 10,
            italic: true,
            color: { argb: "666666" },
        }
        system.getCell(1).alignment = { horizontal: "center" }
        worksheet.mergeCells(`A${system.number}:F${system.number}`)

        // Generate and download
        const buffer = await workbook.xlsx.writeBuffer()
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })

        saveAs(blob, `Monthly Invoices Draft - ${new Date().toLocaleDateString()}.xlsx`)
    }

    useEffect(() => {
        getCustomerQueue()
        getData()
        // Initialize form with default month value
        setValue("month", new Date())
    }, [])

    return (
        <Box sx={{ p: 3 }} component={'form'} onSubmit={handleSubmit(CreateMonthlyInvoice)}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '10px', alignItems: 'flex-end' }}>
                <Typography sx={{ fontSize: "22px", fontWeight: 'bold' }} >
                    Create Monthly Service Invoice</Typography>
                <Box sx={{
                    textAlign: "right", display: "flex", gap: 2

                }}>

                    {originalArray?.length > 0 && <PrimaryButton
                        title={"Download Excel"}
                        onClick={() => downloadMonthlyInvoicesExcel(selectedRows.length > 0 ? selectedRows : originalArray)}
                    />}
                    {selectedRows.length > 0 && <Box sx={{ display: 'flex', gap: '10px' }}>
                        <PrimaryButton
                            bgcolor={Colors.buttonBg}
                            title="Create Invoice"
                            type='submit'

                        // onClick={ ()=> navigate(`/update-customer/${id}`)}


                        />

                    </Box>}
                </Box>

            </Box>
            <Grid container spacing={2} mt={5}>
                <Grid item xs={5} >
                    <SelectField
                        size={'small'}
                        label={'Select Customer :'}
                        disabled={user?.user_type == 'C' ? true : false}
                        options={customerQueue}
                        selected={selectedCustomer}
                        onSelect={async (value) => {
                            setSelectedCustomer(value);
                            setSelectedRows([]);
                            setTotalData([]);
                            setSelectAll(false);
                            setValue('customer', value);

                            // --- Wait for charges to finish ---
                            const chargesData = await getCharges(value?.id);

                            await getCandidateList(null, null, null, value?.id, selectMonth, chargesData)

                        }}

                        error={errors?.customer?.message}
                        register={register("customer", {
                            required: 'Please select customer account.',
                        })}
                    />
                </Grid>
                <Grid item xs={12} md={4} mb={"1%"}>
                    <DatePicker
                        size={"small"}
                        label={"Select Month"}
                        disableFuture={true}
                        openTo="month"
                        views={['month', 'year']}
                        value={selectMonth}
                        minDate={new Date('2023-11-01')}
                        error={errors?.month?.message}
                        register={register("month", {
                            required: "Please enter month.",
                        })}
                        onChange={(date) => handleSelectMonth(date)}
                    />

                </Grid>
            </Grid>
            <Grid container mt={2}>
                <Grid item xs={2}>
                    <InputField
                        label={"Search :"}
                        size={'small'}
                        fullWidth={true}
                        placeholder={"Search"}
                        error={errors?.search?.message}
                        register={register('code', {
                            onChange: (e) => handleSearchChange(false, e.target.value)
                        })}
                    />
                </Grid>
            </Grid>
            <Grid item md={11}>
                {<Box>

                    <Grid container mb={2} >

                    </Grid>



                    {(
                        (
                            <Fragment>
                                <PDFExport landscape={true} paperSize="A4" margin={5} fileName='Import Customers' >

                                    <TableContainer
                                        component={Paper}
                                        sx={{
                                            maxHeight: 'calc(100vh - 200px)', mt: 1, backgroundColor: 'transparent', boxShadow: 'none !important', borderRadius: '0px !important'

                                        }}

                                    >
                                        <Table stickyHeader sx={{ minWidth: 500 }}>
                                            <TableHead>

                                                <Row>
                                                    {tableHead.map((cell, index) => (
                                                        <Cell style={{ textAlign: cell?.name == 'Select' ? 'center' : 'left', paddingRight: cell?.name == 'Select' ? '15px' : '20px' }} className="pdf-table"
                                                            key={index}

                                                        >
                                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                {cell.name == 'Select' && <Checkbox
                                                                    checked={selectedRows.length == 0 ? false : selectAll}
                                                                    disabled={false}
                                                                    onChange={(e) => handleCheckboxChange2(e.target.checked)}
                                                                />}    {cell?.name} {cell?.name == 'Date' && <>&nbsp;<span style={{ height: '20px', cursor: 'pointer' }}><Box component={'img'} onClick={() => { setSort(sort == 'asc' ? 'desc' : 'asc'); handleSort(cell?.key) }} src={Images.sortIcon} width={'18px'}></Box></span></>}
                                                            </Box>
                                                        </Cell>
                                                    ))}
                                                </Row>
                                            </TableHead>
                                            <TableBody>
  {loader ? (
    <Row>
      <Cell colSpan={tableHead.length + 1} align="center">
        <CircularProgress size={28} />
      </Cell>
    </Row>
  ) : candidates?.length > 0 ? (
    candidates.map((item, index) => (
      <Row
        key={index}
        sx={{ border: "1px solid #EEEEEE !important" }}
      >
        <Cell
          style={{ textAlign: "center", paddingLeft: "0px !important" }}
          className="pdf-table"
        >
          <Checkbox
            checked={selectedRows.includes(item)}
            disabled={item?.applicableVisaCharges <= 0}
            onChange={(e) =>
              handleCheckboxChange(item, e.target.checked)
            }
          />
        </Cell>

        <Cell className="pdf-table">{item?.name}</Cell>
        <Cell className="pdf-table">{item?.customer?.name}</Cell>
        <Cell className="pdf-table">{item?.passport_number}</Cell>
        <Cell className="pdf-table">
          {getApplicableCharge(
            salaryCharges,
            item?.change_status_date,
            parseFloat(item?.salary_total)
          )}
        </Cell>
        <Cell className="pdf-table">
          {parseFloat(item?.applicableVisaCharges).toFixed(2)}
        </Cell>
        <Cell className="pdf-table">
                    {getOverstayCharges(item?.overstayDays, charges?.overstay).toFixed(2)}
        </Cell>
      </Row>
    ))
  ) : (
    <Row>
      <Cell
        colSpan={tableHead.length + 1}
        align="center"
        sx={{ fontWeight: 600 }}
      >
        No Data Found
      </Cell>
    </Row>
  )}
</TableBody>


                                        </Table>
                                    </TableContainer>
                                </PDFExport>
                                {/* ========== Pagination ========== */}
                                <Grid container justifyContent={'space-between'} alignItems={'center'} mt={5}>
                                    <Grid item>
                                        <Typography sx={{ fontSize: '14px', fontWeight: 600, color: Colors.charcoalGrey }}>
                                            Total Candidate Count: {totalCandidateCount}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                    <Pagination
                                        count={totalCount}
                                        page={page}
                                        onChange={handleChangePage}
                                        renderItem={(item) => (
                                            <PaginationItem
                                                component="div"
                                                {...item}
                                            />
                                        )}
                                    />
                                    </Grid>
                                </Grid>

                            </Fragment>
                        )
                    )}





                </Box>}





            </Grid>
        </Box>
    )
}

export default CreateMonthlyInvoice